/**
 * Permission Tabs Component
 * 
 * Vertical tab navigation for the permission detail sheet
 */

import { Button } from '@/components/ui/button';

interface Tab {
    id: string;
    label: string;
    hasValue: boolean;
}

interface PermissionTabsProps {
    tabs: Tab[];
    activeTab: string;
    onTabChange: (tabId: string) => void;
}

export function PermissionTabs({ tabs, activeTab, onTabChange }: PermissionTabsProps) {
    return (
        <nav className="flex flex-col py-2">
            {tabs.map((tab) => (
                <Button
                    key={tab.id}
                    variant="ghost"
                    onClick={() => onTabChange(tab.id)}
                    className={`flex items-center justify-between px-4 py-3 text-left text-sm h-auto rounded-none transition-colors ${activeTab === tab.id
                        ? 'bg-white text-gray-900 font-medium'
                        : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700'
                        }`}
                >
                    <span className="flex-1">{tab.label}</span>
                    <span
                        className={`h-2.5 w-2.5 rounded-full ${tab.hasValue
                            ? 'bg-purple-600'
                            : 'bg-gray-300'
                            }`}
                    />
                </Button>
            ))}
        </nav>
    );
}
